"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShapePainter = void 0;
var PathBasedPainter_1 = require("../PathBasedPainter");
/**
 * Base class for basic geometric shape painters (see {@link Shape}).
 */
var ShapePainter = /** @class */ (function (_super) {
    __extends(ShapePainter, _super);
    function ShapePainter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShapePainter.prototype.shouldRepaint = function (previousData, newData) {
        return _super.prototype.shouldRepaint.call(this, previousData, newData)
            || previousData.fillStyle !== newData.fillStyle;
    };
    /**
     * Fills the shape using {@link Shape#fillStyle}.
     */
    ShapePainter.prototype.paintFill = function (store, object) {
        var ctx = store.layers.result.ctx;
        ctx.save();
        if (!object.stroke) {
            this.applyShadowSettings(ctx, object);
        }
        ctx.fillStyle = object.fillStyle;
        this.tracePath(ctx, store, object);
        ctx.fill();
        ctx.restore();
    };
    return ShapePainter;
}(PathBasedPainter_1.PathBasedPainter));
exports.ShapePainter = ShapePainter;
//# sourceMappingURL=ShapePainter.js.map